<template>
  <div>
    <div class="filter-bar mb-sm">
      <breadcrumb></breadcrumb>
      <div class="space"></div>
      <el-button size="small" type="primary" @click="onExport">导出</el-button>
      <el-button slot="reference" size="small" @click="$router.go(-1)"
        >返回</el-button
      >
    </div>
    <div class="content-box">
      <div class="export-box" id="export-box">
        <div class="page face">
          <div class="title">
            <h2>上海市奉贤区{{ userInfo.schoolName }}</h2>
            <h2>教研组工作手册</h2>
          </div>
          <div class="info">
            <h2>
              组别：<span>{{ revertType }}</span>
            </h2>
            <h2>
              组长：<span>{{ groupInfo?.leaderName }}</span>
            </h2>
          </div>
          <div class="schoolYear">
            <h2>
              {{ groupInfo?.schoolYear }}学年{{
                groupInfo?.schoolTerm | revertTerm
              }}
            </h2>
          </div>
        </div>
        <div class="page small-box outline">
          <h1>目录</h1>
          <ul>
            <li>1、教研组概况</li>
            <li>2、教研组成员情况一览表</li>
            <li>3、教研组研究专题（课题）</li>
            <li>4、教研组工作计划</li>
            <li>5、教研组工作行事历</li>
            <li>6、学科拓展情况一览表</li>
            <li>7、教研组青年教师培养</li>
            <li>8、教研组活动记录</li>
            <li>9、教研组专题学习记录</li>
            <li>10、教研组公开课一览表</li>
            <li>11、教研组成员获奖情况一览表</li>
            <li>12、教研组成果汇总一览表</li>
            <li>13、教研组研究专题总结</li>
            <li>14、教研组工作总结</li>
          </ul>
        </div>
        <div class="page topic newTeacher">
          <table>
            <caption class="page-title">
              教研组概况
            </caption>
            <tr>
              <td>组别：{{ revertType }}</td>
              <td>现级别：{{ revertType2 }}</td>
              <td>升级（复验）时间：{{ groupInfo?.upgradeDate }}</td>
            </tr>
            <tr>
              <td colspan="3">升级（复验）已完成</td>
            </tr>
            <tr>
              <td>公开课</td>
              <td>校级（{{ researchGroupStatistics?.openClassNumXj }}）节</td>
              <td>区级（{{ researchGroupStatistics?.openClassNumQj }}）节</td>
            </tr>
            <tr>
              <td>论文</td>
              <td>校级（{{ researchGroupStatistics?.articleNumXj }}）篇</td>
              <td>区级（{{ researchGroupStatistics?.articleNumQj }}）篇</td>
            </tr>
            <tr>
              <td>课题</td>
              <td>校级（{{ researchGroupStatistics?.topicNumXj }}）个</td>
              <td>区级（{{ researchGroupStatistics?.topicNumQj }}）个</td>
            </tr>
          </table>
        </div>
        <div class="page user" v-for="(table, index) in tableData" :key="index">
          <table>
            <caption class="page-title">
              教研组成员情况一览表
            </caption>
            <thead>
              <tr>
                <th>姓名</th>
                <th>性别</th>
                <th>出生年月</th>
                <th>职称</th>
                <th>学历</th>
                <th>教龄</th>
                <th>任课班级</th>
                <th>任课节数</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in table" :key="user.id">
                <td>{{ user.userName }}</td>
                <td>{{ user.userSex }}</td>
                <td>{{ user.birthday }}</td>
                <td>{{ user.teacherArchivesDTO?.academicTitlesDesc }}</td>
                <td>{{ user.teacherArchivesDTO?.educationDesc }}</td>
                <td>{{ user.teacherArchivesDTO?.teachingAge }}</td>
                <td>{{ user.teacherArchivesDTO?.className }}</td>
                <td>
                  {{
                    user.teacherArchivesDTO?.remark &&
                    JSON.parse(user.teacherArchivesDTO.remark)?.teachNum
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="page topic" v-for="table in topicTableData" :key="table.id">
          <table>
            <caption class="page-title">
              教研组研究专题（课题）
            </caption>
            <tbody>
              <tr class="fix-height">
                <td class="label">课题</td>
                <td>{{ table.actTitle }}</td>
                <td class="label">负责人</td>
                <td>{{ table.speakUserNames }}</td>
              </tr>
              <tr>
                <td class="label">参加人员</td>
                <td colspan="4">
                  <span
                    v-for="(user, index) in table.joinUsers"
                    :key="user.userId"
                    >{{ user.userName
                    }}{{
                      index == table.joinUsers.length - 1 ? "" : "、"
                    }}</span
                  >
                </td>
              </tr>
              <tr>
                <td class="label">研究目的</td>
                <td>{{ table.actPlan }}</td>
                <td class="label">完成时间</td>
                <td>
                  {{ table.startDate | formatDate }}～
                  {{ table.endDate | formatDate }}
                </td>
              </tr>
              <tr>
                <td class="label">研究方法</td>
                <td colspan="3">{{ table.actContent }}</td>
              </tr>
              <tr>
                <td class="label">研究步骤</td>
                <td colspan="4" style="text-align: left; vertical-align: top">
                  <ul style="list-style: none">
                    <li
                      style="display: inline"
                      v-for="(node, index) in table.activeNodeTopics"
                      :key="node.id"
                    >
                      {{ index + 1 }}.{{ node.nodeTypeDesc }}&emsp;&emsp;
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="page small-box">
          <div class="page-title title">教研组工作计划</div>
          <div class="content word">
            <pre style="word-break: break-all; white-space: normal">{{
              groupInfo?.plan
            }}</pre>
          </div>
        </div>
        <div
          class="page topic newTeacher2"
          v-for="(table, index) in researchTableData2"
          :key="'researchTableData2' + index"
        >
          <table>
            <caption class="page-title">
              教研组工作行事历
            </caption>
            <thead>
              <tr>
                <th>周次</th>
                <th>主要活动内容</th>
                <th>召集人</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="act in table" :key="act.id">
                <td>{{ act.actWeek }}</td>
                <td>{{ act.actTitle }}</td>
                <td>
                  <span
                    v-for="(user, index) in act.speakUsers"
                    :key="user.userId"
                    >{{ user.userName
                    }}{{ index == act.speakUsers.length - 1 ? "" : "、" }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="page user"
          v-for="(table, index) in afterClassTable"
          :key="'afterClassTable' + index"
        >
          <table>
            <caption class="page-title">
              学科拓展情况一览表
            </caption>
            <thead>
              <tr>
                <th>序号</th>
                <th>名称</th>
                <th>参加人数</th>
                <th>负责人</th>
                <th>活动次数（周）</th>
                <th>活动内容</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(act, index) in table" :key="act.id">
                <td>{{ index + 1 }}</td>
                <td>{{ act.actTitle }}</td>
                <td>{{ act.joinUserNum }}</td>
                <td>{{ act.directorName }}</td>
                <td>{{ act.weekActCount }}</td>
                <td>{{ act.actContent }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="page topic newTeacher"
          v-for="(table, index) in taskInfoListTabel"
          :key="'taskInfoListTabel' + index"
        >
          <table>
            <caption class="page-title">
              教研组青年教师培养
            </caption>
            <tbody>
              <tr>
                <td rowspan="10">
                  <div class="vertical-text">青年教师概况</div>
                </td>
                <td>姓名</td>
                <td>学历</td>
                <td>教龄</td>
                <td>任课班级</td>
                <td>特长</td>
                <td>带教师父</td>
              </tr>
              <tr v-for="user in table" :key="user.id">
                <td>{{ user.teachedName }}</td>
                <td>{{ user.teacherArchivesDTO?.educationDesc }}</td>
                <td>{{ user.teacherArchivesDTO?.teachingAge }}</td>
                <td>{{ user.teacherArchivesDTO?.className }}</td>
                <td>
                  {{
                    user.teacherArchivesDTO?.remark &&
                    JSON.parse(user.teacherArchivesDTO.remark)?.speciality
                  }}
                </td>
                <td>{{ user.teacherName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="page topic"
          v-for="(table, index) in researchTableData"
          :key="table.id"
        >
          <table>
            <caption class="page-title">
              教研组活动记录<span
                style="font-size: 20px; letter-spacing: normal"
                >第{{ index + 1 }}次</span
              >
            </caption>
            <tbody>
              <tr class="fix-height">
                <td class="label">活动时间</td>
                <td>
                  {{ table.startDate | formatDate }}～{{
                    table.endDate | formatDate
                  }}
                </td>
                <td class="label">地点</td>
                <td>{{ table.address }}</td>
              </tr>
              <tr class="fix-height">
                <td class="label">召集人</td>
                <td>{{ table.speakUserNames }}</td>
                <td class="label">内容</td>
                <td>{{ table.actTitle }}</td>
              </tr>
              <tr class="fix-height">
                <td class="label">缺席</td>
                <td>
                  <span
                    v-for="(user, index) in table.absenceUser"
                    :key="user.userId"
                    >{{ user.userName
                    }}{{
                      index == table.absenceUser.length - 1 ? "" : "、"
                    }}</span
                  >
                </td>
                <td class="label">原因</td>
                <td></td>
              </tr>
              <tr>
                <td colspan="4" style="text-align: left; vertical-align: top">
                  <h2 style="margin: 10px">活动过程记载：</h2>
                  <ul>
                    <li
                      v-for="(node, index) in table.activeNodeTopics"
                      :key="node.id"
                    >
                      {{ index + 1 }}、 {{ node.nodeTypeDesc }}
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="page topic newTeacher2"
          v-for="(table, index) in topicTableData2"
          :key="'topicTableDataIndex' + index"
        >
          <table>
            <caption class="page-title">
              教研组专题学习记录
            </caption>
            <thead>
              <tr>
                <th>时间</th>
                <th>内容</th>
                <th>形式</th>
                <th>负责人</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="act in table" :key="act.id">
                <td>{{ act.startDate | formatDate }}</td>
                <td>{{ act.actTitle }}</td>
                <td>{{ act.actForm }}</td>
                <td>
                  <span
                    v-for="(user, index) in act.speakUsers"
                    :key="user.userId"
                    >{{ user.userName
                    }}{{ index == act.speakUsers.length - 1 ? "" : "、" }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="page topic newTeacher2"
          v-for="(table, index) in groupOpenClassStatistics"
          :key="'groupOpenClassStatistics' + index"
        >
          <table>
            <caption class="page-title">
              教研组公开课一览表<span
                style="font-size: 20px; letter-spacing: normal"
                >(含校级)</span
              >
            </caption>
            <thead>
              <tr>
                <th>姓名</th>
                <th>课名</th>
                <th>上课时间</th>
                <th>级别</th>
                <th>评价</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="act in table" :key="act.id">
                <td>{{ act.userName }}</td>
                <td>{{ act.actTitle }}</td>
                <td>{{ act.startDate | formatDate }}</td>
                <td>{{ act.getClassify1Desc }}</td>
                <td>{{ act.evalScore == 0 ? "--" : act.evalScore }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="page topic newTeacher2"
          v-for="(table, index) in groupHonorAwardList"
          :key="'groupHonorAwardList' + index"
        >
          <table>
            <caption class="page-title">
              教研组成员获奖情况一览表
            </caption>
            <thead>
              <tr>
                <th>序号</th>
                <th>姓名</th>
                <th>奖项名称</th>
                <th>级别</th>
                <th>备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(act, i) in table" :key="act.id">
                <td>{{ index * 10 + i + 1 }}</td>
                <td>{{ act.teacherName }}</td>
                <td>{{ act.title }}</td>
                <td>{{ act.ranksDesc }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="page topic newTeacher2"
          v-for="(table, index) in groupArticleList"
          :key="'groupArticleList' + index"
        >
          <table>
            <caption class="page-title">
              教研成果汇总一览表
            </caption>
            <thead>
              <tr>
                <th>序号</th>
                <th>姓名</th>
                <th>论文（课题）名称</th>
                <th>级别</th>
                <th>备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(act, i) in table" :key="act.id">
                <td>{{ index * 10 + i + 1 }}</td>
                <td>{{ act.createName }}</td>
                <td>{{ act.title }}</td>
                <td>{{ act.getClassifyDesc }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- <div
          class="page topic newTeacher"
          v-for="(table, index) in prepareClassTable"
          :key="'prepareClassTable' + index"
        >
          <table>
            <caption class="page-title">
              备课组活动统计表
            </caption>
            <colgroup>
              <col style="width: 100px" />
              <col style="width: 100px" />
              <col style="" />
            </colgroup>
            <thead>
              <tr>
                <th>年级组</th>
                <th>活动次数</th>
                <th>本学期主要解决什么问题</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="act in table" :key="act.id">
                <td>{{ act.gradeGroup }}</td>
                <td>{{ act.expectNum }}</td>
                <td>
                  <pre style="word-break: break-all; white-space: pre-wrap">{{
                    act.problem
                  }}</pre>
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->
        <!-- <div
          class="page user"
          v-for="(table, index) in tableTeacherStatistics"
          :key="'tableTeacherStatistics' + index"
        >
          <table>
            <caption class="page-title">
              教研组成员工作情况统计表
            </caption>
            <thead>
              <tr>
                <th>姓名</th>
                <th>公开课节数</th>
                <th>听课节数</th>
                <th>参加教研活动次数</th>
                <th>补缺次数</th>
                <th>课外活动辅导次数</th>
                <th>指导学生获奖人数等第</th>
                <th>文章经验等发表交流范围及篇数</th>
                <th>获奖情况</th>
                <th>备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in table" :key="user.id">
                <td>{{ user.teacherName }}</td>
                <td>{{ user.hostClassNum }}</td>
                <td>{{ user.joinClassNum }}</td>
                <td>{{ user.joinResearchNum }}</td>
                <td>{{ user.unSignResearchNum }}</td>
                <td>{{ user.afterClassNum }}</td>
                <td>{{ user.afterClassNum }}</td>
                <td>{{ user.articlesNum }}</td>
                <td>{{ user.awardsNum }}</td>
                <td>{{ user.remark }}</td>
              </tr>
            </tbody>
          </table>
        </div> -->
        <div class="page small-box">
          <div class="page-title title">教研组研究专题总结</div>
          <div class="content word">
            <pre style="word-break: break-all; white-space: normal">{{
              groupInfo?.researchSummary
            }}</pre>
          </div>
        </div>
        <div class="page small-box">
          <div class="page-title title">教研组工作总结</div>
          <div class="content word">
            <pre style="word-break: break-all; white-space: normal">{{
              groupInfo?.summary
            }}</pre>
          </div>
        </div>
        <!-- <div class="page small-box">
          <div class="page-title title">学校意见</div>
          <div class="content">
            <div class="info">
              <span>学校领导&nbsp;_____________________</span
              >&nbsp;(签名)&nbsp;_______&nbsp;年&nbsp;_______&nbsp;月&nbsp;_______&nbsp;日
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { postData, postJson } from "../../../http/fetch";
import Breadcrumb from "@/components/Breadcrumb.vue";
import {
  mapFileIcon,
  mapLinkIcon,
  lookFile,
  downloadUrlFile,
} from "@/utils/index.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";

export default {
  components: {
    Breadcrumb,
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    revertTerm(val) {
      switch (val) {
        case 1:
          return "第一学期";
        case 2:
          return "第二学期";
      }
    },
  },
  data() {
    return {
      groupCode: "",
      groupInfo: null,
      loading: false,
      btnLoading: false,
      tableData: [],
      tableTeacherStatistics: [],
      topicTableData: [],
      topicTableData2: [],
      afterClassTable: [],
      researchTableData: [],
      researchTableData2: [],
      actStatistics: null,
      taskInfoListTabel: [],
      prepareClassTable: [],
      groupOpenClassStatistics: [],
      groupHonorAwardList: [],
      groupArticleList: [],
      researchGroupStatistics: null,
      groupTypeOptions: [
        { value: "yx", label: "优秀" },
        { value: "hg", label: "合格" },
        { value: "sf", label: "示范" },
      ],
    };
  },
  mounted() {
    if (sessionStorage.getItem("groupCode")) {
      this.groupCode = sessionStorage.getItem("groupCode");
      this.getDeatail(this.groupCode);
      this.getResearchGroupTeacherList(this.groupCode);
      // this.getGroupTeacherStatistics(this.groupCode);
      // this.getGroupActStatistics(this.groupCode);
      this.getGroupActiveList("research", this.groupCode);
      this.getGroupActiveList("topic", this.groupCode);
      this.getActiveAfterClassList(this.groupCode);
      this.getTeacherTaskInfoList(this.groupCode);
      // this.getActivePrepareClassList(this.groupCode);
      this.getResearchGroupStatistics(this.groupCode);
      this.getGroupOpenClassStatistics(this.groupCode);
      this.getGroupHonorAwardList(this.groupCode);
      this.getGroupArticleList(this.groupCode);
    }
  },
  computed: {
    ...mapState(["userInfo", "isAdmin"]),
    revertType() {
      return this.groupTypeOptions.find(
        (item) => item.value == this.groupInfo?.groupType
      )?.label;
    },
    revertType2() {
      return this.groupTypeOptions.find(
        (item) => item.value == this.groupInfo?.curType
      )?.label;
    },
  },
  methods: {
    mapFileIcon,
    mapLinkIcon,
    lookFile,
    async getDeatail(groupCode) {
      this.loading = true;

      await postData("/researchGroup/getResearchGroupInfo", {
        schoolCode: this.userInfo.orgCode || this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.groupInfo = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getResearchGroupTeacherList(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getResearchGroupTeacherList", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.tableData = this.setTwoDimensionalArray(res);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getGroupActStatistics(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getGroupActStatistics", {
        groupCode,
      })
        .then((res) => {
          this.actStatistics = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getGroupTeacherStatistics(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getGroupTeacherStatistics", {
        groupCode,
      })
        .then((res) => {
          this.tableTeacherStatistics = this.setTwoDimensionalArray(res);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadFile(url, name) {
      //确认下载完成 后 进行下载记录保存
      downloadUrlFile(url, name);
      //保存下载记录
      // postJson("/operator/saveDownloadInfo", {
      // 	infoCode: sessionStorage.getItem("actCode"),
      // 	module: "research",
      // 	operatorId: this.userInfo.userId,
      // 	schoolCode: this.userInfo.schoolCode
      // });
    },
    onExport() {
      const element = document.getElementById("export-box");
      html2canvas(element, {
        allowTaint: true,
        ignoreElements: function () {},
      }).then((canvas) => {
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let pageHeight = (contentWidth / 592.28) * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        let imgWidth = 595.28;
        let imgHeight = (595.28 / contentWidth) * contentHeight;
        let pageData = canvas.toDataURL("image/jpeg", 1.0);
        let PDF = new jsPDF("p", "pt", "a4");
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        PDF.save(this.groupInfo.groupName + ".pdf");
      });
    },
    // 转化函数
    setTwoDimensionalArray(list, num = 10) {
      const listResult = []; // 最终返回的二维数组
      for (let i = 0; i < Math.ceil(list.length / num); i++) {
        listResult[i] = [];
        for (let j = 0; j < num; j++) {
          // 如果是最后一个板块
          if (i === Math.ceil(list.length / num) - 1) {
            if (Math.ceil(list.length % num) !== 0) {
              // 只有最后一个板块的数据在余数以内的才赋值
              if (j < Math.ceil(list.length % num)) {
                listResult[i][j] = list[i * num + j];
              }
            } else {
              // 如果刚好整整一个板块，则全部附上值
              listResult[i][j] = list[i * num + j];
            }
          } else {
            listResult[i][j] = list[i * num + j];
          }
        }
      }
      return listResult;
    },
    async getGroupActiveList(actType, groupCode) {
      this.loading = true;
      await postJson("/researchGroup/getGroupActiveList", {
        schoolCodes: this.schoolCodes,
        operatorId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode,
        pageNum: 1,
        pageSize: -1,
        isAdmin: this.isAdmin / 1,
        actType,
        groupCode,
      })
        .then((res) => {
          if (actType == "topic") {
            this.topicTableData = res.records;
            this.topicTableData2 = this.setTwoDimensionalArray(res.records, 20);
          } else {
            this.researchTableData = res.records.map((u) => ({
              ...u,
              absenceUser: u.joinUsers.filter((u) => !u.isSign),
            }));

            this.researchTableData2 = this.setTwoDimensionalArray(
              res.records,
              20
            );
          }
        })
        .catch((e) => {
          if (actType == "topic") {
            this.topicTableData = [];
            this.topicTableData2 = [];
          } else {
            this.researchTableData = [];
            this.researchTableData2 = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getActiveAfterClassList(groupCode) {
      this.loading = true;
      await postJson("/researchGroup/getActiveAfterClassList", {
        schoolCodes: this.schoolCodes,
        operatorId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode,
        pageNum: 1,
        pageSize: -1,
        isAdmin: this.isAdmin / 1,
        groupCode,
      })
        .then((res) => {
          this.afterClassTable = this.setTwoDimensionalArray(res.records);
        })
        .catch((e) => {
          this.afterClassTable = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTeacherTaskInfoList(groupCode) {
      this.loading = true;
      postJson("/researchGroup/getTeacherTaskInfoList", {
        schoolCode: this.userInfo.schoolCode,
        pageNum: 1,
        pageSize: -1,
        checkStatus: 1,
        operatorId: this.userInfo.userId,
        groupCode,
        isAdmin: this.isAdmin / 1,
      })
        .then((res) => {
          this.taskInfoListTabel = this.setTwoDimensionalArray(res.records);
        })
        .catch((e) => {
          this.taskInfoListTabel = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getActivePrepareClassList(groupCode) {
      this.loading = true;
      await postJson("/researchGroup/getActivePrepareClassList", {
        isAdmin: this.isAdmin / 1,
        operatorId: this.userInfo.userId,
        pageNum: 1,
        pageSize: -1,
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.prepareClassTable = this.setTwoDimensionalArray(res.records);
        })
        .catch((e) => {
          this.prepareClassTable = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getResearchGroupStatistics(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getResearchGroupStatistics", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.researchGroupStatistics = res;
        })
        .catch((e) => {
          this.researchGroupStatistics = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getGroupOpenClassStatistics(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getGroupOpenClassStatistics", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.groupOpenClassStatistics = this.setTwoDimensionalArray(res, 20);
        })
        .catch((e) => {
          this.groupOpenClassStatistics = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getGroupHonorAwardList(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getGroupHonorAwardList", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.groupHonorAwardList = this.setTwoDimensionalArray(res, 20);
        })
        .catch((e) => {
          this.groupHonorAwardList = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getGroupArticleList(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getGroupArticleList", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.groupArticleList = this.setTwoDimensionalArray(res, 20);
        })
        .catch((e) => {
          this.groupArticleList = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
@pageW: 794px;
@pageH: 1123px;
@tableGap: 40px;

@fontSize: 16px;
@fontFamily: "宋体";
.content-box {
  .export-box {
    -webkit-print-color-adjust: exact;
    width: @pageW;
    margin: 0 auto;

    .face {
      position: relative;
      .title {
        padding-top: 150px;
        font-size: 32px;
        h2 {
          font-weight: bold;
          text-align: center;
        }
      }
      .info {
        position: absolute;
        top: 50%;
        left: calc(50% - 44px);
        transform: translate(-50%, -50%);
        width: 40%;
        font-weight: 500;
        h2 {
          font-size: 18px;
          position: relative;
          margin: 10px 0;
          &::after {
            content: "";
            position: absolute;
            width: 100%;
            background-color: #000;
            height: 1px;
            bottom: 0;
            left: 44px;
          }
          span {
            position: absolute;
            left: calc(50% + 44px);
            transform: translateX(-50%);
            font-weight: 700;
          }
        }
      }
      .schoolYear {
        position: absolute;
        bottom: 150px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 20px;
        font-weight: 700;
      }
    }
    .user {
      table {
        border-collapse: collapse;
        transform: rotate(90deg);
        transform-origin: 0px 0px;
        position: absolute;
        top: calc(@tableGap / 2);
        left: calc(100% - @tableGap);
        width: calc(@pageH - @tableGap);
        // height: calc(@pageW - @tableGap * 2);
        box-sizing: border-box;
        th,
        td {
          font-size: @fontSize;
          border: 1px solid black;
          text-align: center;
        }
        tr {
          height: calc(calc(@pageW - @tableGap * 2 - 32px) / 11);
          overflow: hidden;
        }
        caption {
          font-size: 24px;
        }
      }
    }
    .topic {
      padding: calc(@tableGap);
      box-sizing: border-box;
      overflow: hidden;
      table {
        width: calc(@pageW - @tableGap * 2);
        height: calc(@pageH - @tableGap * 3 - 2px);
        // height: 100%;
        border-collapse: collapse;
        box-sizing: border-box;
        overflow: hidden;
        caption {
          font-size: 24px;
        }
        th,
        td {
          font-size: @fontSize;
          font-family: @fontFamily;
          border: 1px solid black;
          text-align: center;
          overflow: hidden;
        }
        .label {
          width: 100px;
        }
        .fix-height {
          height: 40px;
        }
      }
    }
    .newTeacher {
      table {
        height: unset;
        table-layout: fixed;
        tr {
          font-size: @fontSize;
          font-family: @fontFamily;
          height: calc(calc(@pageH - @tableGap * 2 - 32px) / 11);
          .vertical-text {
            margin: 0 auto;
            writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
            writing-mode: tb-lr; /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
            letter-spacing: 20px;
          }
        }
      }
    }
    .newTeacher2 {
      table {
        height: unset;
        table-layout: fixed;
        tr {
          font-size: @fontSize;
          font-family: @fontFamily;
          height: calc(calc(@pageH - @tableGap * 2 - 32px) / 21);
          .vertical-text {
            margin: 0 auto;
            writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
            writing-mode: tb-lr; /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
            letter-spacing: 20px;
          }
        }
      }
    }
    .small-box {
      width: 100%;
      height: 100%;
      display: flex;
      box-sizing: border-box;
      flex-direction: column;
      padding: @tableGap;
      .title {
        width: 100%;
        height: 30px;
        font-size: 24px;
        text-align: center;
        letter-spacing: 24px;
      }
      .content {
        font-size: @fontSize;
        font-family: @fontFamily;
        position: relative;
        flex: 1;
        margin-top: 10px;
        padding: @tableGap;
        border: 1px solid black;
        white-space: pre;
        .word {
          font-size: @fontSize;
          font-family: @fontFamily;
        }
        .info {
          font-size: @fontSize;
          font-family: @fontFamily;
          position: absolute;
          bottom: 50px;
          right: 50px;
        }
      }
    }

    .page {
      position: relative;
      background-color: #fff;
      height: @pageH;
      width: @pageW;
      .page-title {
        letter-spacing: 28px;
      }
    }
    .outline {
      h1 {
        text-align: center;
        font-weight: bold;
        font-size: 32px;
        letter-spacing: 32px;
        line-height: 96px;
      }
      ul {
        list-style: none;
        margin-left: 30px;
        li {
          font-size: 24px;
          line-height: 48px;
        }
      }
    }
  }
}
</style>
